<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/new-zealand/ata-rangi')">Ata Rangi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/bell-hill-vineyards')">Bell Hill Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/craggy-range')">Craggy Range
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/dog-point-vineyards')">Dog Point Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/millton-vineyards-and-winery')">Millton
                        Vineyards and Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/pyramid-valley-vineyards')">Pyramid Valley
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/rippon-vineyards')">Rippon Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/trinity-hill')">Trinity Hill
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Ata Rangi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Come già sappiamo, quando si acquistano vini pregiati ci vuole pazienza per vedere un ritorno. Gli investitori suggeriscono che almeno 10 anni sono ottimali, anche se realisticamente inizieresti a vedere qualcosa di significativo dopo sette. Con Bordeaux e Borgogna che sono la scelta dei bookmaker, sono già così ben consolidati che i margini sono stretti (a meno che tu non entri nel mercato primeur, che è un gioco completamente separato).
                        <br><br>
                        Mentre gettiamo le nostre reti per qualcosa di diverso, sarebbe sciocco liquidare i vini del nuovo mondo come opportunità di investimento. Tuttavia, bisogna procedere con cautela qui, con molte cantine boutique che ottengono riconoscimenti tra i critici, è ancora troppo presto per dire se l'invecchiamento è alla pari con i loro fratelli francesi. Un vigneto che non ha questo problema è Ata Rangi.
                    </div>

                    <div class="howto-title2">Da produttore di latte a pioniere del vino</div>
                    <div class="howto-text">
                        Fondata nel 1980 su un "recinto di pecore sassoso e arido ai margini del piccolo Martinborough
                        village", Clive Patton, un ex allevatore di latte, iniziò a realizzare il suo sogno che alla fine sarebbe diventato
                        vedere i suoi vini distintivi spingere l'intera regione sotto i riflettori enologici. Nonostante molto
                        costernazione, Patten non era uno sciocco; ha subito visto il potenziale del terreno. Drenaggio gratuito
                        le terrazze di ghiaia (senza dimenticare le scarse precipitazioni nell'Isola del Nord) lo hanno reso un gioco da ragazzi
                        Patton. L'aggiunta dell'enologo Helen Masters al team e quasi 40 anni dopo, calcoliamo
                        il suo istinto era giusto.
                    </div>

                    <div class="howto-title2">Il Pinot del 2010 è stato il primo Grand Cru della Nuova Zelanda</div>
                    <div class="howto-text">
                        Probabilmente il produttore più famoso della regione, i vini Ata Rangi sono seri contendenti sul
                        circuito del vino pregiato. Il Pinot Nero è il vino di punta della tenuta e si dice che sia un
                        "clone di stivali di gomma" di Romanee Conti (un clone che si sostiene sia stato portato in Nuova Zelanda nel
                        stivale di un operaio che aveva prelevato clandestinamente un taleo dal famoso demanio). I prezzi sono alti
                        (per i vini del nuovo mondo) ma lo sono anche i punteggi, pensa che gli ultimi due anni siano coerenti con la metà degli anni '90
                        decenni. Eppure il vero interesse di Ata Rangi per gli investitori di vini pregiati è che la sua età è superiore
                        a molti della regione, raggiungendo facilmente il leggendario decennio necessario per vedere decente
                        ritorna.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Ata Rangi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wie wir bereits wissen, braucht es beim Kauf guter Weine Geduld, um eine Rendite zu erzielen. Investoren gehen davon aus, dass mindestens 10 Jahre optimal sind, obwohl realistischerweise nach sieben Jahren etwas Bedeutendes zu erwarten wäre. Da Bordeaux und Burgund die Wahl der Buchmacher sind, sind sie bereits so gut etabliert, dass die Gewinnspannen gering sind (es sei denn, man steigt in den Primeur-Markt ein, der ein ganz anderes Ballspiel ist).
                        <br><br>
                        Da wir unsere Netze nach etwas anderem auswerfen, wäre es töricht, Weine aus der neuen Welt als Investitionsmöglichkeiten abzutun. Allerdings muss man hier vorsichtig vorgehen, da viele Boutique-Weingüter bei Kritikern Anerkennung finden, ist es noch zu früh, um zu sagen, ob die Alterung ihren französischen Geschwistern ebenbürtig ist. Ein Weinberg, bei dem dieses Problem nicht auftritt, ist Ata Rangi.
                    </div>

                    <div class="howto-title2">Vom Milchbauern zum Weinpionier</div>
                    <div class="howto-text">
                        1980 auf einer „steinigen, kargen Schafweide am Rande des kleinen Martinborough“ gegründet
                        Village“ machte sich Clive Patton, ein ehemaliger Milchbauer, daran, seinen Traum zu verwirklichen, der letztendlich Wirklichkeit werden sollte
                        Erleben Sie, wie seine typischen Weine die gesamte Region ins önologische Rampenlicht rücken. Trotz vielem
                        Bestürzung, Patten war kein Dummkopf; Er erkannte sofort das Potenzial des Landes. Freie Entleerung
                        Kiesterrassen (nicht zu vergessen die geringen Niederschläge auf der Nordinsel) machten es zu einem Kinderspiel
                        Patton. Die Aufnahme der Winzerin Helen Masters in das Team und fast 40 Jahre später, schätzen wir
                        sein Bauchgefühl stimmte.
                    </div>

                    <div class="howto-title2">Der Pinot des Jahres 2010 war der erste Grand Cru Neuseelands</div>
                    <div class="howto-text">
                        Ata Rangi-Weine sind wohl der berühmteste Produzent der Region und ernsthafte Konkurrenten auf dem Markt
                        Feiner Weinrundgang. Der Pinot Noir ist der Flaggschiffwein des Weinguts und gilt als einer der besten
                        „Gummistiefel-Klon“ von Romanee Conti (ein Klon, der angeblich im Jahr 1993 nach Neuseeland gebracht wurde).
                        Stiefel eines Arbeiters, der heimlich in der berühmten Domäne einen Holzeinschlag gemacht hatte). Die Preise sind hoch
                        (für Weine aus der Neuen Welt), aber das gilt auch für die Bewertungen, denken Sie an konstant niedrige bis mittlere 90er-Werte für die letzten beiden
                        Jahrzehnte. Das eigentliche Interesse von Ata Rangi für Investoren in erlesenen Weinen besteht jedoch darin, dass seine Alterungsfähigkeit überlegen ist
                        Für viele aus der Region ist es einfach, das sagenumwobene Jahrzehnt zu erreichen, das nötig ist, um anständig zu sehen
                        kehrt zurück.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Ata Rangi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Comme nous le savons déjà, lors de l'achat de vins fins, il faut de la patience pour voir un retour. Les investisseurs suggèrent qu'au moins 10 ans est optimal, bien que de manière réaliste, vous commenceriez à voir quelque chose d'important après sept ans. Bordeaux et la Bourgogne étant le choix des bookmakers, ils sont déjà si bien établis que les marges sont étroites (à moins que vous n'entriez sur le marché des primeurs, qui est un jeu de balle à part entière).
                        <br><br>
                        Alors que nous jetons nos filets pour quelque chose de différent, il serait insensé de considérer les vins du nouveau monde comme des opportunités d'investissement. Cependant, il faut faire preuve de prudence ici, avec de nombreux établissements vinicoles de plus en plus reconnus par les critiques, il est encore trop tôt pour dire si le vieillissement est comparable à celui de leurs frères et sœurs français. Un vignoble qui n'a pas ce problème est Ata Rangi.
                    </div>

                    <div class="howto-title2">De producteur laitier à pionnier du vin</div>
                    <div class="howto-text">
                        Fondée en 1980 sur un «enclos de moutons pierreux et stérile au bord du petit Martinborough
                        village », Clive Patton, un ancien producteur laitier, s'est mis à créer son rêve qui finirait par
                        voir ses vins emblématiques propulser toute la région sous les projecteurs œnologiques. Malgré beaucoup
                        consternation, Patten n'était pas dupe ; il a immédiatement vu le potentiel de la terre. Vidange gratuite
                        les terrasses de galets (sans oublier les faibles précipitations de l'île du Nord) en ont fait une évidence pour
                        Patton. L'ajout de la vigneronne Helen Masters à l'équipe et près de 40 ans plus tard, nous estimons
                        son intuition avait raison.
                    </div>

                    <div class="howto-title2">Le Pinot des années 2010 a été le premier Grand Cru de Nouvelle-Zélande</div>
                    <div class="howto-text">
                        Sans doute le producteur le plus célèbre de la région, les vins d'Ata Rangi sont de sérieux prétendants sur le
                        circuit des vins fins. Le Pinot Noir est le vin phare du domaine et on dit qu'il est un
                        "gumboot clone" de Romanee Conti (un clone qui aurait été amené en Nouvelle-Zélande dans le
                        botte d'un ouvrier qui avait pris une coupe clandestine du célèbre domaine). Les prix sont élevés
                        (pour les vins du nouveau monde) mais les scores le sont aussi, pensez à un bas-milieu des années 90 constant pour les deux derniers
                        décennies. Pourtant, le véritable intérêt d'Ata Rangi pour les investisseurs en vins fins est que sa durée de vie est supérieure
                        à beaucoup de la région, atteignant facilement la décennie légendaire nécessaire pour voir décent
                        Retour.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Ata Rangi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        As we already know, when buying fine wines it takes patience to see a return. Investors suggest at least 10 years is optimum, although realistically you would start seeing something significant after seven. With Bordeaux and Burgundy being the bookies choice, they are already so well-established that margins are narrow (unless you get in on the primeur market, which is whole separate ballgame).
                        <br><br>
                        As we cast our nets for something different, it would be foolish to dismiss new world wines as investment opportunities. However, one needs to tread carefully here, with many boutique wineries gaining recognition among critics, it is still too early to say whether ageing is on a parr with their French siblings. One vineyard that does not have that problem is Ata Rangi.
                    </div>

                    <div class="howto-title2">From dairy farmer to wine pionner</div>
                    <div class="howto-text">
                        Founded in 1980 on a “stony, barren sheep paddock at the edge of the small Martinborough
                        village”, Clive Patton an ex-dairy farmer, set about creating his dream that would ultimately
                        see his hallmark wines propel the entire region into the oenological spotlight. Despite much
                        consternation, Patten was no fool; he immediately saw the land’s potential. Free draining
                        shingle terraces (not forgetting the low rainfall in the North Island) made it a no-brainer for
                        Patton. The addition of winemaker Helen Masters to the team and almost 40 years on, we reckon
                        his gut-feeling was right.
                    </div>

                    <div class="howto-title2">2010s Pinot was the first Grand Cru of New Zealand</div>
                    <div class="howto-text">
                        Arguably the most famous producer in the region, Ata Rangi wines are serious contenders on the
                        fine wine circuit. The Pinot Noir is the flagship wine of the estate and is said to be a
                        “gumboot clone” of Romanee Conti (a clone claimed to have been brought to New Zealand in the
                        boot of a worker who had taken a clandestine cutting from the famous domain). Prices are high
                        (for new world wines) yet so are the scores, think consistent low-mid-90s for the past two
                        decades. Yet Ata Rangi’s real interest for fine wine investors is that its ageabilty is superior
                        to many from the region, easily attaining the fabled decade needed in order to see decent
                        returns.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AtaRangi",
    data() {
        return {
            select: {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
            items: [
                {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
                {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
                {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
                {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
                {report: 'Millton Vineyards and Winery', src: '/wine-guide/new-zealand/millton-vineyards-and-winery'},
                {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
                {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
                {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Ata Rangi | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the world-renowned Ata Rangi wine producer, known for crafting premium, sustainably grown wines from the heart of New Zealand\'s Martinborough region.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
